// 토큰/웹검색 한도 초과 모달 + 상향 요청(독립) + 마운트 시 요청 상태 조회.
import { useState, useEffect } from 'react';
import { chatAPI } from '../../../api/client';
import { alertDialog } from '../../../components/AppDialog';

export default function useChatLimits() {
  const [limitModal, setLimitModal]         = useState(null); // { used, limit }
  const [webLimitModal, setWebLimitModal]   = useState(null); // { used, limit } 웹 검색 한도 초과
  const [limitReason, setLimitReason]       = useState('');
  const [limitRequested, setLimitRequested] = useState(false);
  const [webLimitRequested, setWebLimitRequested] = useState(false);

  useEffect(() => {
    chatAPI.getLimitRequestStatus().then((r) => setLimitRequested(r.data.has_pending)).catch(() => {});
  }, []);

  const handleWebLimitRequest = async () => {
    try {
      await chatAPI.requestLimit(undefined, 'web_search');
      setWebLimitRequested(true);
    } catch (err) {
      if (err.response?.status === 409) setWebLimitRequested(true);
      else alertDialog('요청 접수 중 오류가 발생했습니다.');
    }
  };

  const handleLimitRequest = async () => {
    try {
      await chatAPI.requestLimit(limitReason || undefined);
      setLimitRequested(true);
    } catch (err) {
      if (err.response?.status === 409) {
        setLimitRequested(true); // 이미 요청됨
      } else {
        alertDialog('요청 접수 중 오류가 발생했습니다.');
      }
    }
  };

  return {
    limitModal, setLimitModal, webLimitModal, setWebLimitModal, limitReason, setLimitReason,
    limitRequested, setLimitRequested, webLimitRequested, setWebLimitRequested,
    handleLimitRequest, handleWebLimitRequest,
  };
}
